import ManageTrustedUsersModalContainer from './containers/ManageTrustedUsersModalContainer'

export default ManageTrustedUsersModalContainer
